import { useEffect, useState } from 'react';
import client from '../api/client';

const roleColor = { SALES_PARTNER:'#eff4ff', AREA_MANAGER:'#f3f0ff', REGIONAL_MANAGER:'#fdf2f8' };
const roleText = { SALES_PARTNER:'#1a3cff', AREA_MANAGER:'#5b21b6', REGIONAL_MANAGER:'#be185d' };

export default function Applications() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('PENDING');
  const [msg, setMsg] = useState('');
  const [declineModal, setDeclineModal] = useState(null);
  const [viewModal, setViewModal] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteReason, setDeleteReason] = useState('');
  const [deleteOtp, setDeleteOtp] = useState('');
  const [approveModal, setApproveModal] = useState(null);
  const [approveOtp, setApproveOtp] = useState('');
  const [regions, setRegions] = useState([]);
  const [areas, setAreas] = useState([]);
  const [finalRole, setFinalRole] = useState('SALES_PARTNER');
  const [finalRegionId, setFinalRegionId] = useState('');
  const [finalAreaId, setFinalAreaId] = useState('');
  const [declineOtp, setDeclineOtp] = useState('');
  const [reinstateLoading, setReinstateLoading] = useState(null);
  const [reason, setReason] = useState('');
  const [notes, setNotes] = useState('');
  const [actionLoading, setActionLoading] = useState(false);

  const load = () => {
    setLoading(true);
    const status = tab === 'ALL' ? '' : tab;
    Promise.all([
      client.get('/admin/affiliate/applications' + (status ? '?status=' + status : '')),
      client.get('/admin/affiliate/regions'),
      client.get('/admin/affiliate/areas')
    ])
      .then(([appsRes, regionsRes, areasRes]) => {
        setApps(appsRes.data || []);
        setRegions(regionsRes.data || []);
        setAreas(areasRes.data || []);
      })
      .catch(() => {
        setApps([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [tab]);

  const requestOtp = async (id, action) => {
    setActionLoading(action + '_otp');
    try {
      await client.post('/admin/affiliate/applications/' + id + '/request-otp', { action });
      setMsg('OTP sent to your email for ' + action.toLowerCase() + '.');
    } catch(e) {
      setMsg(e.response?.data || 'Failed to send OTP');
    } finally {
      setActionLoading(false);
    }
  };

  const approve = async () => {
    if (!approveModal) return;
    setActionLoading('approve');
    try {
      const r = await client.post('/admin/affiliate/applications/' + approveModal + '/approve', { otp: approveOtp, roleApplied: finalRole, regionId: finalRegionId, areaId: finalAreaId });
      setMsg('Approved! Rep account created. Ref code: ' + r.data.refCode);
      setApproveModal(null);
      setApproveOtp('');
      setFinalRole('SALES_PARTNER');
      setFinalRegionId('');
      setFinalAreaId('');
      load();
    } catch(e) { setMsg(e.response?.data || 'Failed'); } finally { setActionLoading(false); }
  };

  const decline = async () => {
    setActionLoading('decline');
    try {
      await client.post('/admin/affiliate/applications/' + declineModal + '/reject', { reason, adminNotes: notes, otp: declineOtp });
      setMsg('Application declined.');
      setDeclineModal(null);
      setReason('');
      setNotes('');
      setDeclineOtp('');
      load();
    } catch(e) { setMsg(e.response?.data || 'Failed'); } finally { setActionLoading(false); }
  };


  const deleteApplication = async () => {
    if (!deleteModal) return;
    setActionLoading('delete');
    try {
      await client.post('/admin/affiliate/applications/' + deleteModal + '/delete', {
        reason: deleteReason,
        otp: deleteOtp
      });
      setMsg('Application deleted.');
      setDeleteModal(null);
      setDeleteReason('');
      setDeleteOtp('');
      load();
    } catch(e) {
      setMsg(e.response?.data || 'Delete failed');
    } finally {
      setActionLoading(false);
    }
  };


  const reinstate = async (id) => {
    if (!window.confirm('Move this application back to Pending?')) return;
    setReinstateLoading(id);
    try {
      await client.post('/admin/affiliate/applications/' + id + '/reinstate');
      setMsg('Application reinstated to pending.');
      load();
    } catch (e) {
      setMsg(e.response?.data || 'Reinstate failed');
    } finally {
      setReinstateLoading(null);
    }
  };

  const reapplyDate = (declinedAt) => {
    if (!declinedAt) return null;
    const d = new Date(declinedAt);
    d.setDate(d.getDate() + 90);
    return d.toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' });
  };

  const tabs = ['PENDING','ALL','DECLINED'];
  const tabLabel = { PENDING:'Pending', ALL:'All Applications', DECLINED:'Declined' };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h1 style={{ color:'#000', fontSize:22, fontWeight:800, margin:'0 0 4px', fontFamily:'Georgia,serif' }}>Rep Applications</h1>
          <p style={{ color:'#555', fontSize:13, margin:0 }}>Review and manage partner applications</p>
        </div>
      </div>

      {msg && <div style={{ background:'#f0fff6', border:'1px solid #b2dfdb', borderRadius:8, padding:'10px 16px', color:'#0a8a40', fontSize:13, marginBottom:16 }}>{msg} <button onClick={()=>setMsg('')} style={{ background:'none', border:'none', color:'#0a8a40', cursor:'pointer', marginLeft:8 }}>✕</button></div>}

      <div style={{ display:'flex', gap:8, marginBottom:20, borderBottom:'1px solid #eee', paddingBottom:12 }}>
        {tabs.map(t => (
          <button key={t} onClick={()=>setTab(t)}
            style={{ padding:'8px 18px', background:tab===t?'#1a3cff':'#fff', color:tab===t?'#fff':'#444', border:tab===t?'none':'1px solid #ddd', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}>
            {tabLabel[t]}
          </button>
        ))}
      </div>

      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #eee', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
          <thead>
            <tr style={{ background:'#f9f9f9', borderBottom:'1px solid #eee' }}>
              {['Name','Email','Phone','Role','City','Experience','Applied','Status', 'Actions'].map(h => (
                <th key={h} style={{ color:'#555', fontSize:11, fontWeight:700, textAlign:'left', padding:'10px 8px', textTransform:'uppercase', letterSpacing:'0.3px' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} style={{ color:'#888', padding:24, textAlign:'center' }}>Loading...</td></tr>
            ) : apps.length === 0 ? (
              <tr><td colSpan={9} style={{ color:'#888', padding:24, textAlign:'center' }}>No {tabLabel[tab].toLowerCase()} applications</td></tr>
            ) : apps.map(a => (
              <tr key={a.id} style={{ borderBottom:'1px solid #f5f5f5' }}>
                <td style={{ padding:'12px 14px', color:'#000', fontWeight:700 }}>{a.name}</td>
                <td style={{ padding:'12px 14px', color:'#333', fontSize:13 }}>{a.email}</td>
                <td style={{ padding:'12px 14px', color:'#555', fontSize:13 }}>{a.phone||'—'}</td>
                <td style={{ padding:'12px 14px' }}>
                  <span style={{ background:roleColor[a.roleApplied]||'#f5f5f5', color:roleText[a.roleApplied]||'#444', padding:'3px 8px', borderRadius:4, fontSize:11, fontWeight:700 }}>
                    {(a.roleApplied||'SALES_PARTNER').replace(/_/g,' ')}
                  </span>
                </td>
                <td style={{ padding:'12px 14px', color:'#555', fontSize:13 }}>{a.city||'—'}</td>
                <td style={{ padding:'10px 8px', color:'#555', fontSize:13, maxWidth:120 }}>
                  <div style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{a.experience||'—'}</div>
                </td>
                <td style={{ padding:'12px 14px', color:'#888', fontSize:12 }}>{a.createdAt ? new Date(a.createdAt).toLocaleDateString() : '—'}</td>
                <td style={{ padding:'12px 14px' }}>
                  <span style={{ background:a.status==='PENDING'?'#fff8ec':a.status==='APPROVED'?'#f0fff6':'#fff5f5', color:a.status==='PENDING'?'#b45309':a.status==='APPROVED'?'#0a8a40':'#c0392b', padding:'3px 8px', borderRadius:4, fontSize:12, fontWeight:700 }}>
                    {a.status}
                  </span>
                </td>
                <td style={{ padding:'12px 14px' }}>
                  {tab === 'DECLINED' ? (
                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                      <span style={{ color:'#888', fontSize:12 }}>
                        {reapplyDate(a.declinedAt) ? 'Eligible: ' + reapplyDate(a.declinedAt) : '—'}
                      </span>
                      <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                        <button style={{ padding:'5px 12px', background:'#eff4ff', color:'#1a3cff', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:'pointer' }}
                          onClick={()=>setViewModal(a)}>
                          View
                        </button>
                        <button style={{ padding:'5px 12px', background:'#f0fff6', color:'#0a8a40', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:reinstateLoading===a.id?'not-allowed':'pointer', opacity:reinstateLoading===a.id?0.6:1 }}
                          onClick={()=>reinstate(a.id)} disabled={reinstateLoading===a.id}>
                          {reinstateLoading===a.id?'Moving...':'Reinstate'}
                        </button>
                        <button style={{ padding:'5px 12px', background:'#fff0f0', color:'#b91c1c', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:'pointer' }}
                          onClick={()=>setDeleteModal(a.id)}>
                          Delete
                        </button>
                        {a.resumeUrl && (
                          /* RESUME-VIEW-FIX-V1: fetch via JWT, then open blob URL */
                          <button onClick={async () => {
                            try {
                              const res = await client.get('/admin/affiliate/applications/' + a.id + '/resume');
                              if (res.data && res.data.resumeUrl) window.open(res.data.resumeUrl, '_blank');
                              else alert('Resume URL not available');
                            } catch (e) { alert('Failed to load resume: ' + (e.response?.data?.message || e.message)); }
                          }} style={{ padding:'5px 12px', background:'#f5f5f5', color:'#444', border:'none', borderRadius:6, fontSize:12, fontWeight:700, cursor:'pointer' }}>
                            Resume
                          </button>
                        )}
                      </div>
                    </div>
                  ) : a.status === 'PENDING' ? (
                    <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                      <button style={{ padding:'4px 8px', background:'#eff4ff', color:'#1a3cff', border:'none', borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}
                        onClick={()=>setViewModal(a)}>
                        View
                      </button>
                      <button style={{ padding:'4px 8px', background:'#f0fff6', color:'#0a8a40', border:'none', borderRadius:6, fontSize:11, fontWeight:700, cursor:actionLoading===a.id?'not-allowed':'pointer', opacity:actionLoading===a.id?0.6:1 }}
                        onClick={()=>{ /* APPROVE-PREFILL-V1 */ setFinalRole(a.roleApplied||'SALES_PARTNER'); setFinalRegionId(a.regionId||''); setFinalAreaId(a.areaId||''); setApproveModal(a.id); }} disabled={!!actionLoading}>
                        {actionLoading===a.id?'Approving...':'Approve'}
                      </button>
                      <button style={{ padding:'4px 8px', background:'#fff5f5', color:'#c0392b', border:'none', borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}
                        onClick={()=>setDeclineModal(a.id)} disabled={!!actionLoading}>
                        Decline
                      </button>
                      <button style={{ padding:'4px 8px', background:'#fff0f0', color:'#b91c1c', border:'none', borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}
                        onClick={()=>setDeleteModal(a.id)} disabled={!!actionLoading}>
                        Delete
                      </button>
                      {a.resumeUrl && (
                        /* RESUME-VIEW-FIX-V1: fetch via JWT, then open blob URL */
                        <button onClick={async () => {
                          try {
                            const res = await client.get('/admin/affiliate/applications/' + a.id + '/resume');
                            if (res.data && res.data.resumeUrl) window.open(res.data.resumeUrl, '_blank');
                            else alert('Resume URL not available');
                          } catch (e) { alert('Failed to load resume: ' + (e.response?.data?.message || e.message)); }
                        }} style={{ padding:'4px 8px', background:'#f5f5f5', color:'#444', border:'none', borderRadius:6, fontSize:11, fontWeight:700, cursor:'pointer' }}>
                          Resume
                        </button>
                      )}
                    </div>
                  ) : (
                    <span style={{ color:'#aaa', fontSize:12 }}>—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>



      {approveModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:32, width:420, border:'1px solid #eee' }}>
            <h3 style={{ color:'#000', margin:'0 0 6px', fontFamily:'Georgia,serif' }}>Approve Application</h3>
            <p style={{ color:'#666', fontSize:13, marginBottom:20 }}>Assign final role and territory, then send OTP for final approval.</p>

            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>Final Role *</label>
            <select value={finalRole} onChange={e=>setFinalRole(e.target.value)} style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:14, boxSizing:'border-box' }}>
              <option value="SALES_PARTNER">Sales Rep</option>
              <option value="AREA_MANAGER">Area Manager</option>
              <option value="REGIONAL_MANAGER">Regional Manager</option>
            </select>

            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>Final Region / State *</label>
            <select value={finalRegionId} onChange={e=>{ setFinalRegionId(e.target.value); setFinalAreaId(''); }} style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:14, boxSizing:'border-box' }}>
              <option value="">Select region</option>
              {regions.filter(r=>r.is_active || r.isActive).map(r => <option key={r.id} value={r.id}>{r.name} ({r.state_code})</option>)}
            </select>

            {finalRole !== 'REGIONAL_MANAGER' && (
              <>
                <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>Final Area / City *</label>
                <select value={finalAreaId} onChange={e=>setFinalAreaId(e.target.value)} style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:14, boxSizing:'border-box' }}>
                  <option value="">Select area</option>
                  {areas.filter(a=>(a.is_active || a.isActive) && (!finalRegionId || a.region_id === finalRegionId)).map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                </select>
              </>
            )}

            <button style={{ width:'100%', padding:'10px', background:'#eff4ff', color:'#1a3cff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer', marginBottom:14 }}
              onClick={()=>requestOtp(approveModal, 'APPROVE')} disabled={!!actionLoading}>
              {actionLoading==='APPROVE_otp'?'Sending OTP...':'Send OTP'}
            </button>
            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>OTP Code *</label>
            <input style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:20, boxSizing:'border-box' }}
              placeholder="Enter OTP" value={approveOtp} onChange={e=>setApproveOtp(e.target.value)} />
            <div style={{ display:'flex', gap:10 }}>
              <button style={{ flex:1, padding:'11px', background:'#0a8a40', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:actionLoading==='approve'?'not-allowed':'pointer', opacity:actionLoading==='approve'?0.6:1 }}
                onClick={approve} disabled={actionLoading==='approve'}>
                {actionLoading==='approve'?'Approving...':'Approve'}
              </button>
              <button style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}
                onClick={()=>{ setApproveModal(null); setApproveOtp(''); }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {viewModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:32, width:620, border:'1px solid #eee', maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ color:'#000', margin:'0 0 18px', fontFamily:'Georgia,serif' }}>Application Details</h3>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:18 }}>
              <div><b>Name:</b><br/>{viewModal.name || '—'}</div>
              <div><b>Email:</b><br/>{viewModal.email || '—'}</div>
              <div><b>Phone:</b><br/>{viewModal.phone || '—'}</div>
              <div><b>Role:</b><br/>{(viewModal.roleApplied || 'SALES_PARTNER').replace(/_/g,' ')}</div>
              <div><b>Requested Area/City:</b><br/>{viewModal.city || '—'}</div>
              <div><b>Status:</b><br/>{viewModal.status || '—'}</div>
            </div>
            <div style={{ marginBottom:14 }}>
              <b>Experience:</b>
              <div style={{ marginTop:6, padding:12, background:'#f9f9f9', border:'1px solid #eee', borderRadius:8, whiteSpace:'pre-wrap' }}>{viewModal.experience || '—'}</div>
            </div>
            <div style={{ marginBottom:20 }}>
              <b>Motivation:</b>
              <div style={{ marginTop:6, padding:12, background:'#f9f9f9', border:'1px solid #eee', borderRadius:8, whiteSpace:'pre-wrap' }}>{viewModal.motivation || '—'}</div>
            </div>
            <button style={{ width:'100%', padding:'11px', background:'#1a3cff', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}
              onClick={()=>setViewModal(null)}>Close</button>
          </div>
        </div>
      )}

      {deleteModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:32, width:460, border:'1px solid #eee' }}>
            <h3 style={{ color:'#b91c1c', margin:'0 0 6px', fontFamily:'Georgia,serif' }}>Delete Application</h3>
            <p style={{ color:'#666', fontSize:13, marginBottom:20 }}>SUPER_ADMIN only. This requires OTP and will soft-delete the application.</p>
            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>Delete Reason *</label>
            <input style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:14, boxSizing:'border-box' }}
              placeholder="e.g. Spam, duplicate, test application" value={deleteReason} onChange={e=>setDeleteReason(e.target.value)} />
            <button style={{ width:'100%', padding:'10px', background:'#fff0f0', color:'#b91c1c', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer', marginBottom:14 }}
              onClick={()=>requestOtp(deleteModal, 'DELETE')} disabled={!!actionLoading}>
              {actionLoading==='DELETE_otp'?'Sending OTP...':'Send OTP to Super Admin'}
            </button>
            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>OTP Code *</label>
            <input style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:20, boxSizing:'border-box' }}
              placeholder="Enter OTP" value={deleteOtp} onChange={e=>setDeleteOtp(e.target.value)} />
            <div style={{ display:'flex', gap:10 }}>
              <button style={{ flex:1, padding:'11px', background:'#b91c1c', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:actionLoading==='delete'?'not-allowed':'pointer', opacity:actionLoading==='delete'?0.6:1 }}
                onClick={deleteApplication} disabled={actionLoading==='delete'}>
                {actionLoading==='delete'?'Deleting...':'Delete'}
              </button>
              <button style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}
                onClick={()=>{ setDeleteModal(null); setDeleteReason(''); setDeleteOtp(''); }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {declineModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:32, width:420, border:'1px solid #eee' }}>
            <h3 style={{ color:'#000', margin:'0 0 6px', fontFamily:'Georgia,serif' }}>Decline Application</h3>
            <p style={{ color:'#666', fontSize:13, marginBottom:20 }}>The applicant will be notified by email. They may reapply after 90 days.</p>
            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>Reason for Applicant *</label>
            <input style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:14, boxSizing:'border-box' }}
              placeholder="e.g. Not enough experience at this time" value={reason} onChange={e=>setReason(e.target.value)} />
            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>Internal Notes (not shown to applicant)</label>
            <textarea style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:20, boxSizing:'border-box', height:80, resize:'vertical' }}
              placeholder="Internal notes for your team..." value={notes} onChange={e=>setNotes(e.target.value)} />
            <button style={{ width:'100%', padding:'10px', background:'#eff4ff', color:'#1a3cff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer', marginBottom:14 }}
              onClick={()=>requestOtp(declineModal, 'DECLINE')} disabled={!!actionLoading}>
              {actionLoading==='DECLINE_otp'?'Sending OTP...':'Send OTP'}
            </button>
            <label style={{ color:'#333', fontSize:12, fontWeight:700, display:'block', marginBottom:6, textTransform:'uppercase' }}>OTP Code *</label>
            <input style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, color:'#000', outline:'none', marginBottom:20, boxSizing:'border-box' }}
              placeholder="Enter OTP" value={declineOtp} onChange={e=>setDeclineOtp(e.target.value)} />
            <div style={{ display:'flex', gap:10 }}>
              <button style={{ flex:1, padding:'11px', background:'#1a3cff', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:actionLoading==='decline'?'not-allowed':'pointer', opacity:actionLoading==='decline'?0.6:1 }}
                onClick={decline} disabled={actionLoading==='decline'}>
                {actionLoading==='decline'?'Declining...':'Decline Application'}
              </button>
              <button style={{ flex:1, padding:'11px', background:'#fff', color:'#555', border:'1px solid #ddd', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer' }}
                onClick={()=>{ setDeclineModal(null); setReason(''); setNotes(''); setDeclineOtp(''); }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
